import type { UseQueryResult } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";

import { enrichmentQueryKeys } from "app/pages/sales-intelligence/modules/enrichment/queries/key-factory/queryKeyFactory";
import type { EnrichedState } from "app/pages/sales-intelligence/modules/enrichment/store/type";
import { EnrichmentStatus } from "app/pages/sales-intelligence/modules/enrichment/store/type";
import salesApiService from "app/pages/sales-intelligence/services/salesApiService";
import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";

const useEnrichmentList = (
    { enabled = true }: { enabled?: boolean } = {},
): UseQueryResult<EnrichedState[]> & { hasLoadingItems: boolean } => {
    const queryData = useQuery({
        queryKey: enrichmentQueryKeys.lists(),
        retry: false,
        queryFn(): Promise<EnrichedState[]> {
            return salesApiService.enrichment.fetchLists();
        },
        enabled: enabled && salesSettingsHelper.isCsvEnrichmentEnabled(),
    });

    return {
        ...queryData,
        hasLoadingItems: queryData.data?.some((item) => item.status === EnrichmentStatus.InProgress) ?? false,
    };
};

export default useEnrichmentList;
